import { handleApiError, handlePermissionError } from '../utils'

export default {
  methods: {
    /**
     * Maneja errores de API de manera consistente
     * @param {Error} error - El error capturado
     * @param {string} defaultMessage - Mensaje por defecto para errores generales
     * @param {string} permissionMessage - Mensaje específico para errores de permisos
     */
    handleApiError (error, defaultMessage = 'Ha ocurrido un error.', permissionMessage = 'No tienes permisos para realizar esta acción.') {
      handleApiError(error, this, defaultMessage, permissionMessage)
    },

    /**
     * Maneja específicamente errores de permisos
     * @param {Error} error - El error capturado
     * @param {string} message - Mensaje personalizado para el error de permisos
     * @returns {boolean} true si fue un error de permisos
     */
    handlePermissionError (error, message = 'No tienes permisos para realizar esta acción.') {
      return handlePermissionError(error, this, message)
    }
  }
}
